module.exports = __webpack_public_path__ + "img/company.d7912395.svg";